export const getUserWorkplace = (workplace: string) => workplace === '' ? localStorage.getItem('workplace') : workplace;
